import type { JSX } from 'react'
import { Edit } from '@mui/icons-material'
import { Grid, IconButton, Typography } from '@mui/material'

import useStyles from './index.styles'

interface IProps {
  label: string
  value?: string | JSX.Element
  xs?: number
  canEdit?: boolean
  onEdit?: () => void
}

const OrderField = (props: IProps) => {
  const { label, value, xs = 2, canEdit, onEdit } = props

  const classes = useStyles

  return (
    <Grid
      container={true}
      size={xs}
      sx={{
        justifyItems: 'center',
        alignContent: 'flex-start',
      }}
    >
      <Grid size={11}>
        <Typography variant="overline" sx={classes.summaryFieldTitle}>
          {label}
        </Typography>

        {canEdit && (
          <IconButton color="primary" onClick={onEdit} aria-label={`Edit ${label}`} size="small">
            <Edit />
          </IconButton>
        )}
      </Grid>
      <Grid size={12}>
        {(typeof value === 'string' || value === undefined) && <Typography variant="body1">{value || '-'}</Typography>}
        {typeof value !== 'string' && value ? value : undefined}
      </Grid>
    </Grid>
  )
}

export default OrderField
